var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarbe01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Farbe-01__Icn/40px/Farbe-01",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Farbe-01__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Farbe-01__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Farbe-01__Icn/40px/Plus-Tools",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Farbe-01__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Farbe-01__Rectangle",
    d: "M12 12H28V28H12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarbe01);
export default __webpack_public_path__ + "static/media/Farbe-01.5a1972f0cb8aec48ba0359cc2e87fb12.svg";
export { ForwardRef as ReactComponent };